import { styled } from '@mui/material';
import React from 'react';
import diagonalLinesRight from '../../assets/patterns/diagonal_lines_right.png';

const Root = styled('div')(({ theme, isActive }) => ({
  borderBottomRightRadius: '16px',
  borderTopRightRadius: '16px',
  width: '100%',
  height: '100%',
  backgroundColor: isActive ? '#F6F9F9' : theme.palette.porcelain['100Base'],
  padding: '1px',
}));

const Pattern = styled('div')(({ theme, isActive }) => ({
  width: '100%',
  height: '100%',
  borderBottomRightRadius: '16px',
  borderTopRightRadius: '16px',
  background: isActive
    ? `url(${diagonalLinesRight}), linear-gradient(179deg, #F6F9F9 0.67%, #F4F5F6 99.22%)`
    : `url(${diagonalLinesRight}), linear-gradient(179deg, #DDE1E3 0.67%, #E3E6E8 99.22%)`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'start',
  paddingTop: '16px',
}));

const IconSlot = styled('div')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '24px',
  height: '24px',
  cursor: 'pointer',
  userSelect: 'none',
}));

const HandleRightSmall = ({
  children,
  width = '30px',
  minWidth = '30px',
  height = 'auto',
  isActive = false,
  onIconClick,
  iconAriaLabel = 'handle action',
  ...props
}) => {
  const handleKeyDown = (e) => {
    if (!onIconClick) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onIconClick();
    }
  };
  return (
    <Root
      isActive={isActive}
      sx={{
        width: width,
        minWidth: minWidth,
        height: height,
      }}
      {...props}
    >
      <Pattern isActive={isActive}>
        {onIconClick ? (
          <IconSlot
            role="button"
            tabIndex={0}
            aria-label={iconAriaLabel}
            onClick={onIconClick}
            onKeyDown={handleKeyDown}
          >
            {children}
          </IconSlot>
        ) : (
          children
        )}
      </Pattern>
    </Root>
  );
};

export default HandleRightSmall;
